import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { ApiService } from "@ehrCore/api/api.service";
import { EROLES } from "@ehrCore/constants/role.constants";
import { IRoutingVariables } from "@ehrSharedResources/models/routing.model";
import { IScrapedData } from "@ehrSharedResources/models/scraped-data.model";
import { LocalStorageHandlerService } from "@ehrSharedResources/services/local-storage-handler/local-storage-handler.service";
import { ExtensionService } from "src/app/athena-one-integration/shared/service/extension.service";
import { EACTIVE_TAB } from "src/app/ehr-extension/routes/cdi-reviewer/routes/cdi-wrapper/model/cdi-reviewer.model";

@Injectable({
  providedIn: "root"
})
export class RouteHandlerService {
  routeMap = {
    nonPatient: {
      [EROLES.CDI_REVIEWER]: "cdi-reviewer",
      [EROLES.PROVIDER]: "provider",
      [EROLES.MEDICAL_ASSISTANT]: "medical-assistant"
    },
    patient: {
      [EROLES.PROVIDER]: "provider",
      [EROLES.CDI_REVIEWER]: "cdi-reviewer",
      [EROLES.MEDICAL_ASSISTANT]: "medical-assistant"
    }
  };

  baseRoute = "ehr-extension";

  constructor(
    private router: Router,
  ) { }


  private _processScrapedData(scrapedData: IScrapedData): {
    athenaPatientId: number | null;
    encounterId: number | null;
  } {
    const athenaPatientId = scrapedData && scrapedData.athena_patient_id;
    const encounterId = scrapedData && scrapedData.encounter_id;

    return {
      athenaPatientId,
      encounterId
    };
  }

  async process({
    userDetails, scrapedData
  }: IRoutingVariables) {

    const { athenaPatientId, encounterId } = this._processScrapedData(scrapedData);
    const redirectUrl = `/${this.baseRoute}/${this.routeMap.patient[userDetails.role]}`;

    if (athenaPatientId) {
      return this.router.navigate([redirectUrl],
        {
          queryParams: { encounterId, athenaMemberId: athenaPatientId },
          skipLocationChange: true
        });
    } else {
      return this.router.navigate([redirectUrl], { skipLocationChange: true });
    }
  }

}
